export default {"src":"/_next/static/media/eye.07f3044e.svg","height":512,"width":512};